import {Component, Input} from '@angular/core';
import {Product} from '@app/core/product/domain/dtos/product';

@Component({
  selector: 'ep-add-to-cart-button',
  templateUrl: './add-to-cart-button.component.html',
  styleUrls: ['./add-to-cart-button.component.scss'],
  host: {
    'class': 'add-to-cart-button',
    '[class]': `[
      'add-to-cart-button--' + size,
    ]`,
  },
  inputs: ['size'],
})
export class AddToCartButtonComponent {

  @Input() product?: Product;

  @Input() showPrice: boolean = false;

  @Input() size: 'small' | 'large' = 'small';

}
